$(() => {
  $("form.new_venue select[multiple], form.edit_venue select[multiple]").select2();  
})
